import { takeLatest, call, put } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import editCourse from 'api/administration/courses/Edit'
import { ICourseModel } from 'models/course.model'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'
import * as fromActions from '../../actions/courses.action'

async function handleEditCourse(course: ICourseModel, courseId: string) {
  return await editCourse(course, courseId)
}

function* editCourseEffectSaga(action: any) {
  try {
    yield call(handleEditCourse, action.payload.course, action.payload.courseId)

    const redirectPath = action.payload.redirectPath
    if (redirectPath) {
      if (action.payload.dc3AssociatePublish) {
        yield put(
          push({
            pathname: redirectPath,
            state: {
              dc3PublishNotification: {
                courseName: action.payload.courseName || '',
              },
            },
          })
        )
      } else {
        yield put(push(redirectPath))
      }
    } else if (action.payload.onlySave) {
      yield put(push('/administration/courses/'))
    } else {
      yield put(fromActions.Actions.getCourse(action.payload.courseId))
      yield put(
        push(`/administration/courses/${action.payload.courseId}/lessons/`)
      )
    }

    if (!action.payload.dc3AssociatePublish) {
      SuccessToast(I18n.t('administration.toastMessages.published'))
    }
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.publishError'))
    console.log('error: ', error)
  }
}

export function* publishCourseWatcherSaga() {
  yield takeLatest(fromActions.PUBLISH_COURSE, editCourseEffectSaga)
}
